import { useEffect, useState } from 'react';
import LoadingSpinner from '../LoadingSpinner.jsx';
import ModalError from '../Modal/ModalError.jsx';
import useQueryEffect from '/src/hooks/useQueryEffect.js';
import { useCleanPlotsMutation } from '/src/redux/importExportApi.js';
import useConfirmCallback from '/src/hooks/useConfirmCallback';
import ModalConfirm from '../Modal/ModalConfirm';

export default function MapDataClean({onClose}){
    const [error, setError] = useState(null);
    const [cleanPlots, { error: cleanError, isLoading: isCleaning, isSuccess: isCleanSuccess, data: cleanResult }] = useCleanPlotsMutation();
    const [showResult, setShowResult] = useState(false);
    const [confirmThen, onConfirm] = useConfirmCallback();

    const userTookAction = useQueryEffect(error=>{
        setError(error);
        setShowResult(!error);
    },[isCleanSuccess],[cleanError]);

    function onCleanBtn(){
        confirmThen(choice=>{
            if(choice){
                userTookAction();
                cleanPlots();
            }
        });
    }

    function onDoneBtn(){
        setShowResult(false);
        setError(null);
        if(onClose) onClose();
    }

    return (
        <div>
            {error && <ModalError title="Error" message={error.message} description={error.status || error.code} callback={()=>setError(null)} />}
            {onConfirm && <ModalConfirm message="Are you sure you want to delete all unused lots? This cannot be undone." callback={onConfirm} />}
            <h4 className='text-xl m-4 font-light'>Data Clean</h4>
            <div className='py-3 px-4'>
                {((isCleaning || (showResult && !cleanResult)) && (
                    <button disabled={true} className='btn w-full font-bold p-4 shadow-lg uppercase text-lg flex'>
                        <span>Cleaning...</span>
                        <LoadingSpinner className='w-6' />
                    </button>
                )) || (showResult && (
                    <div>
                        <h5 className='text-xl mb-2'>Clean Complete</h5>
                        <p className='mb-4'>Removed {cleanResult.deletedCount + ''} unused lots</p>
                        <button className='btn' onClick={()=>onDoneBtn()}>Done</button>
                    </div>
                )) || (
                    <div>
                        <button onClick={()=>onCleanBtn()} className='btn w-full font-bold p-4 shadow-lg uppercase text-lg'>Clean</button>
                        <p className='my-3 text-sm'>This will remove all imported data that is not currently plotted on the map</p>
                    </div>
                )}
            </div>
        </div>
    );
}